import React, {useContext} from 'react'

export const UserContext = React.createContext({
  error: null,
  loading: true,
  value: null,
  auth: null,
})

const useUserContext = () => useContext(UserContext)

export default useUserContext
